<nav
  class="sidebar"
  [class.icon-only]="layout.sidebarPresentation() === 'icon-only'"
  aria-label="Primary"
>
  @if (layout.band() === 'xl') {
    <button
      type="button"
      class="collapse-toggle"
      (click)="toggleCollapse()"
      [attr.aria-expanded]="!layout.sidebarCollapsed()"
      [attr.aria-label]="layout.sidebarCollapsed() ? 'Expand navigation' : 'Collapse navigation'"
      data-testid="nav-collapse-toggle"
    >
      <fa-icon [icon]="collapseIcon" aria-hidden="true" />
    </button>
  }
  <ul class="sidebar-list">
    @for (entry of visibleEntries(); track entry.path) {
      <li>
        <a
          class="sidebar-row"
          [routerLink]="entry.path"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          [attr.data-testid]="entry.testId"
        >
          <fa-icon [icon]="entry.icon" aria-hidden="true" />
          <span class="sidebar-label">{{ entry.label }}</span>
        </a>
      </li>
    }
  </ul>
</nav>
